import * as pdfjs from "pdfjs-dist";
import pdfWorker from "pdfjs-dist/build/pdf.worker.min.mjs?url";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;

const PRINT_SCALE = 3;
const PT_PER_INCH = 72;

const rasterizePdfToImage = async (url) => {
  const data = await (await fetch(url)).arrayBuffer();
  const pdf = await pdfjs.getDocument({ data }).promise;
  const page = await pdf.getPage(1);

  const base = page.getViewport({ scale: 1 });
  const widthIn = base.width / PT_PER_INCH;
  const heightIn = base.height / PT_PER_INCH;

  const viewport = page.getViewport({ scale: PRINT_SCALE });
  const canvas = document.createElement("canvas");
  canvas.width = viewport.width;
  canvas.height = viewport.height;
  const context = canvas.getContext("2d");
  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, canvas.width, canvas.height);
  await page.render({ canvasContext: context, viewport }).promise;

  return { dataUrl: canvas.toDataURL("image/png"), widthIn, heightIn };
};

export const printPdfUrl = async (url) => {
  const { dataUrl, widthIn, heightIn } = await rasterizePdfToImage(url);
  URL.revokeObjectURL(url);

  const printContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <style>
          @page {
            size: ${widthIn}in ${heightIn}in;
            margin: 0;
          }
          html, body {
            margin: 0;
            padding: 0;
            width: ${widthIn}in;
            height: ${heightIn}in;
          }
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        </style>
      </head>
      <body>
        <img src="${dataUrl}" />
      </body>
    </html>
  `;

  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";

  const cleanup = () => {
    if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
  };

  iframe.onload = () => {
    const frameWindow = iframe.contentWindow;
    frameWindow.focus();
    frameWindow.print();
    frameWindow.onafterprint = cleanup;
    setTimeout(cleanup, 60000);
  };

  iframe.srcdoc = printContent;
  document.body.appendChild(iframe);
};
